import importExport from './import&export.vue'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$refs['importExport'].importProduct();
    },
    // 导出 --新接口
    onExport() {
      let params = {
        appCode: "soft-vote-web",
        paramMap: {},
        reportName: "productInfoExport",
      };
      this.$q.excelConfig.export(params).then((res) => {
        console.log(res)
        this.$message({
          type: "success",
          message: "导出成功,请在导出列表中查看",
        });
      });
    },
  }
}